module.exports = __webpack_public_path__ + "img/save.f6b5cc9f.svg";